/**
 * Central export file for common components
 * Makes imports cleaner and more maintainable
 */

// Error handling
export { 
  ErrorBoundary, 
  withErrorBoundary, 
  ApiErrorBoundary 
} from './ErrorBoundary';

// Loading states
export { 
  LoadingSpinner, 
  LoadingContainer, 
  InlineLoading, 
  LoadingOverlay 
} from './LoadingSpinner';

// Existing components
export { default as Badge } from './Badge';
export { default as Card } from './Card';
export { default as Chart } from './Chart';
export { default as ProgressBar } from './ProgressBar';
export { default as ProgressIndicator } from './ProgressIndicator';
export { default as SearchableGLAccountDropdown } from './SearchableGLAccountDropdown';